import React, { useState, useEffect } from 'react';
import "./topNavStyles.scss";
import { NavLink } from 'react-router-dom';
import { Box, Typography, Divider, List, ListItem, ListItemButton, IconButton, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

function isCookieSet(cookieName: string) {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');
    return cookies.some(cookie => cookie.startsWith(`${cookieName}=`));
}

const isUserAuthenticated = isCookieSet('email');

export const TopNav = (props: any) => {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuthStatus = () => {
            setIsUserAuthenticated(isCookieSet('email'));
        };
    
        // Check the authentication status immediately
        checkAuthStatus();
    
        // Check the authentication status every second
        const intervalId = setInterval(checkAuthStatus, 1000);
    
        // Clear the interval when the component unmounts
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h4" sx={{ my: 2 }} className='mainTitleGradient'>
                Aggie
            </Typography>
            <Divider />
            <List id="drawerList">
                <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <NavLink to="/" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                            Home
                        </NavLink>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <NavLink to="/about" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                            About
                        </NavLink>
                    </ListItemButton>
                </ListItem>
                {/* <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <NavLink to="/help" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                            How Can I Help
                        </NavLink>
                    </ListItemButton>
                </ListItem> */}
                <ListItem disablePadding>
                    {isUserAuthenticated && (
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <NavLink to="/fulfill" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                                I Can Help
                            </NavLink>
                        </ListItemButton>
                    )}
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <NavLink to="/news" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                            Aggie News
                        </NavLink>
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton sx={{ textAlign: 'center' }}>
                        <NavLink to="/news" className={(navData: any) => (navData.isActive ? 'active drawerNavButton' : 'drawerNavButton')}>
                            Sign In
                        </NavLink>
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;
    const drawerWidth = 240;
    return (
        <div className="topNav" >
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <div id='drawerLinks'>
                    <NavLink to="/" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                        Home
                    </NavLink>
                    <NavLink to="/about" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                        About
                    </NavLink>
                    {/* <NavLink to="/help" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                        How Can I Help
                    </NavLink> */}
                    {isUserAuthenticated && (
                        <NavLink to="/fulfill" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                            I Can Help
                        </NavLink>
                    )}
                    <NavLink to="/news" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                        Aggie News
                    </NavLink>
                    <NavLink to="/signin" className={(navData: any) => (navData.isActive ? 'active navButton' : 'navButton')}>
                        Sign In
                    </NavLink>
                </div>
            </Box>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: 'none' } }}
                id="drawerButton"
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                {drawer}
            </Drawer>
        </div>
    )
}
